import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-sm font-light text-gray-700 w-full" }
const _hoisted_2 = { class: "grid grid-cols-2 gap-0 md:gap-4 gap-y-4" }
const _hoisted_3 = { class: "text-sm col-span-2 md:col-span-1" }
const _hoisted_4 = { class: "text-sm col-span-2 md:col-span-1" }
const _hoisted_5 = { class: "text-sm col-span-2 md:col-span-1" }
const _hoisted_6 = { class: "flex w-full items-end col-span-2 md:col-span-1" }
const _hoisted_7 = { class: "w-1/2 md:w-[65%]" }
const _hoisted_8 = { class: "w-1/2 md:w-[35%]" }
const _hoisted_9 = { class: "text-sm col-span-2" }
const _hoisted_10 = { class: "mt-8" }
const _hoisted_11 = { class: "text-red-500 mt-3 col-span-2 text-center" }

import axios, {
		Axios
	} from 'axios'

	// Auth
	import { 
		Auth
	} from '@/api/Auth'
	
	// Language
	import {
		useI18n
	} from 'vue-i18n'

	// Queries
	import{
		getJobByRecordId
	}from '@/modules/search/queries'

	// Router
	import {
		useRouter,
		useRoute
	} from 'vue-router'

	// Store
	import { 
		localesStore
	} from '@/store/locales'
	import { 
		store as _jobStore
	} from '@/store/job'
	import { 
		store as _valueListStore
	} from '@/store/valueLists'

	// Types
	import { 
		FindParameters,
		LangTypes,
		JobDetail,
		ValueList,
		ValueListValue,
		WeddingDetail
	} from '@/types'

	// Vue
	import {
		inject,
		ref
	} from 'vue'

	
	const __default__ = { name: 'LoginForm' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

	// Api
	const jobStore = _jobStore()
	const valueListStore = _valueListStore()
	const _localesStore = localesStore()

	const router = useRouter()
	const route = useRoute()

	const {t} = useI18n()

	const weddingInfo = ref({} as WeddingDetail)
	const password = ref<string>('')
	const loginLoading = ref(false)
	const loginError = ref(false)
	const i18n = inject<any>('i18n')

	function validate() {
		let isValid = true

		if(!weddingInfo.value.brideName) isValid = false
		else if(!weddingInfo.value.groomName) isValid = false
		else if(!weddingInfo.value.weddingDate) isValid = false
		else if(!weddingInfo.value.weddingTimeHour) isValid = false
		else if(!weddingInfo.value.weddingTimeMinute) isValid = false
		else if(!password.value) isValid = false

		return isValid
	}

	const jobDetails = ref({} as JobDetail)

	async function login() {
		loginLoading.value = true

		if(validate()) {
			let response = await Auth.signIn(weddingInfo.value, password.value)

			if (!response.authenticated) {
				loginError.value = true
				loginLoading.value = false
				return
			}

			const jobID = response?.job?.jobID
			await getJobDetails(jobID)
			
			jobStore.job.jobID = response?.job?.jobID
			jobStore.job.loggedIn = response?.job?.loggedIn
			jobStore.job.jobDetails = jobDetails.value
			loginLoading.value = false

			// handle redirects
			router.push(route?.query?.redirect ? String(route?.query?.redirect) : { name: 'Search' })
		}
		else {
			loginError.value = true
		}

		loginLoading.value = false
	}

	async function getJobDetails(jobID: string) {
		const scriptParams = JSON.stringify({
			language: _localesStore.getFmLanguage
		})

		const recordId: FindParameters = {
			query: [
				{'_kp_jobs_id': jobID}
			],
			'script.prerequest': 'Set Language',
			'script.prerequest.param': scriptParams
		} 
		try{
			let result = await getJobByRecordId(recordId)
			jobDetails.value = {
				displayName: result?.response?.data[0]?.fieldData?.name_bride_groom_display,
				weddingDate: result?.response?.data[0]?.fieldData?.zctDateFormatted,
				weddingTime: result?.response?.data[0]?.fieldData?.time_start,
				scenes: (result?.response?.data[0]?.portalData?.portal_scenes) as [],
				hasHadSongsSubmitted: Boolean(result?.response?.data[0]?.fieldData?.hasHadSongsSubmitted),
				notesKanji: result?.response?.data[0]?.fieldData?.['job__JOBS_INFO__jobID__cre::websiteNotesKanji'],
				notesKana: result?.response?.data[0]?.fieldData?.['job__JOBS_INFO__jobID__cre::websiteNotesKana'],
				notesEnglish: result?.response?.data[0]?.fieldData?.['job__JOBS_INFO__jobID__cre::websiteNotesEnglish']
			}
			jobStore.job.numDaysUpdateSong = result?.response?.data[0]?.fieldData?.['jobs__PREFERENCES__cart::changeSongsNumDaysBeforeJob']

			return result
		}
		catch(e) {
			console.log(e)
		}

	}
	// #endregion

	const timeListHours = [
		{
			label: '00',
			value: '00'
		},
		{
			label: '01',
			value: '01'
		},
		{
			label: '02',
			value: '02'
		},
		{
			label: '03',
			value: '03'
		},
		{
			label: '04',
			value: '04'
		},
		{
			label: '05',
			value: '05'
		},
		{
			label: '06',
			value: '06'
		},
		{
			label: '07',
			value: '07'
		},
		{
			label: '08',
			value: '08'
		},
		{
			label: '09',
			value: '09'
		},
		{
			label: '10',
			value:'10'
		},
		{
			label: '11',
			value:'11'
		},
		{
			label: '12',
			value:'12'
		},
		{
			label: '13',
			value:'13'
		},
		{
			label: '14',
			value:'14'
		},
		{
			label: '15',
			value:'15'
		},
		{
			label: '16',
			value:'16'
		},
		{
			label: '17',
			value:'17'
		},
		{
			label: '18',
			value:'18'
		},
		{
			label: '19',
			value:'19'
		},
		{
			label: '20',
			value:'20'
		},
		{
			label: '21',
			value:'21'
		},
		{
			label: '22',
			value:'22'
		},
		{
			label: '23',
			value:'23'
		},
	]

	const timeListMinutes = [
		{
			label: '00',
			value: '00'
		},
		{
			label: '05',
			value: '05'
		},
		{
			label: '10',
			value: '10'
		},
		{
			label: '15',
			value: '15'
		},
		{
			label: '20',
			value: '20'
		},
		{
			label: '25',
			value: '25'
		},
		{
			label: '30',
			value: '30'
		},
		{
			label: '35',
			value: '35'
		},
		{
			label: '40',
			value: '40'
		},
		{
			label: '45',
			value: '45'
		},
		{
			label: '50',
			value: '50'
		},
		{
			label: '55',
			value: '55'
		},
	]
	
	const showPassword = ref(false)

	function toggleShowPassword() {
		const passwordField = document.querySelector('#password')

		if(passwordField?.getAttribute('type') === 'password') {
			passwordField.setAttribute('type', 'text')
			showPassword.value = true
		}
		else{
			passwordField?.setAttribute('type', 'password')
			showPassword.value = false
		}
	}

return (_ctx: any,_cache: any) => {
  const _component_tw_input = _resolveComponent("tw-input")!
  const _component_tw_select = _resolveComponent("tw-select")!
  const _component_EyeIcon = _resolveComponent("EyeIcon")!
  const _component_EyeSlashIcon = _resolveComponent("EyeSlashIcon")!
  const _component_tw_button = _resolveComponent("tw-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("h1", _hoisted_1, _toDisplayString(_unref(t)('login.title')), 1)
    ]),
    _createElementVNode("form", {
      class: "mt-8",
      onSubmit: _withModifiers(login, ["prevent"])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_tw_input, {
            modelValue: weddingInfo.value.groomName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((weddingInfo.value.groomName) = $event)),
            id: "groom",
            required: true,
            label: _unref(t)('login.groom'),
            class: "text-md"
          }, null, 8, ["modelValue", "label"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_tw_input, {
            modelValue: weddingInfo.value.brideName,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((weddingInfo.value.brideName) = $event)),
            id: "bride",
            required: true,
            label: _unref(t)('login.bride'),
            class: "text-md"
          }, null, 8, ["modelValue", "label"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_tw_input, {
            modelValue: weddingInfo.value.weddingDate,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((weddingInfo.value.weddingDate) = $event)),
            id: "wedding-date",
            required: true,
            type: "date",
            label: _unref(t)('login.weddingDate'),
            class: "text-md"
          }, null, 8, ["modelValue", "label"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_tw_select, {
              modelValue: weddingInfo.value.weddingTimeHour,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((weddingInfo.value.weddingTimeHour) = $event)),
              "aria-label": "Reception Time (hours)",
              id: "wedding-time-hours",
              required: "",
              class: "rounded-r-none",
              placeholder: _unref(t)('time.hour'),
              options: timeListHours,
              label: _unref(t)('login.weddingTime')
            }, null, 8, ["modelValue", "placeholder", "label"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_tw_select, {
              modelValue: weddingInfo.value.weddingTimeMinute,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((weddingInfo.value.weddingTimeMinute) = $event)),
              "aria-label": "Reception Time (minutes)",
              id: "wedding-time-minutes",
              class: "rounded-l-none -ml-[1px]",
              required: "",
              "hide-required": "",
              placeholder: _unref(t)('time.minute'),
              options: timeListMinutes
            }, null, 8, ["modelValue", "placeholder"])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_tw_input, {
            modelValue: password.value,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((password).value = $event)),
            id: "password",
            required: true,
            type: "password",
            label: _unref(t)('login.password'),
            validation: _unref(t)('login.passwordValidation'),
            class: "text-md"
          }, {
            trailing_inline: _withCtx(() => [
              _createElementVNode("button", {
                type: "button",
                onClick: toggleShowPassword,
                class: "border-none bg-transparent hover:bg-transparent"
              }, [
                (!showPassword.value)
                  ? (_openBlock(), _createBlock(_component_EyeIcon, {
                      key: 0,
                      class: "h-5"
                    }))
                  : (_openBlock(), _createBlock(_component_EyeSlashIcon, {
                      key: 1,
                      class: "h-5"
                    }))
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "label", "validation"])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_tw_button, {
          type: "submit",
          class: "btn-brand font-medium w-full",
          disabled: loginLoading.value,
          loading: loginLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('login.login')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "loading"]),
        _withDirectives(_createElementVNode("div", _hoisted_11, [
          _createElementVNode("p", null, _toDisplayString(_unref(t)('login.invalidEmailPassword')), 1)
        ], 512), [
          [_vShow, loginError.value]
        ])
      ])
    ], 32)
  ], 64))
}
}

})